import { render, staticRenderFns } from "./NumberHeaderSmall.vue?vue&type=template&id=4211d400&scoped=true"
import script from "./NumberHeaderSmall.vue?vue&type=script&lang=js"
export * from "./NumberHeaderSmall.vue?vue&type=script&lang=js"
import style0 from "./NumberHeaderSmall.vue?vue&type=style&index=0&id=4211d400&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4211d400",
  null
  
)

export default component.exports